<template>
  <el-dialog
    top="15vh"
    class="food-record-edit__dialog"
    :title="$t('Fault.faultDesc')"
    width="800px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="drawerVisible"
  >
    <Description>
      <DescriptionItem :span="24" :label="$t('Fault.productModel')">
        <span>{{ FaultData.productName | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Fault.deviceCode')">
        <span>{{ FaultData.deviceCode | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Device.installationArea')">
        <span>{{ FaultData.installationArea | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Fault.userName')">
        <span>{{ FaultData.userName | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Fault.phone')">
        <span>{{ FaultData.phone | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Common.email')">
        <span>{{ FaultData.email | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Fault.errorTime')">
        <span>{{ FaultData.faultTime | formatTime }}</span>
      </DescriptionItem>
      <DescriptionItem
        :span="24"
        :label="$t('Fault.dealTime')"
        v-if="row.productType === 'refrigerator'"
      >
        <span>{{ FaultData.dealTime | formatTime }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Fault.faultDesc')">
        <span>{{ FaultData.feedbackContent | format }}</span>
      </DescriptionItem>
      <DescriptionItem :span="24" :label="$t('Fault.faultDescImg')">
        <span v-for="(imgId, i) in FaultData.feedbackPictures" :key="i" class="hl-img">
          <hl-image :src="createImgUrl(imgId)" width="120px" height="120px" alt=""></hl-image>
        </span>
      </DescriptionItem>
    </Description>
  </el-dialog>
</template>

<script>
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'
import { format, formatTime, formatNumWithComma, createImgUrl } from '@/utils/utils'
import Image from '@/components/CommonTable/Image'
export default {
  name: 'FaultDetail',
  components: {
    Description,
    DescriptionItem,
    'hl-image': Image
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  filters: {
    format(val) {
      return format(val)
    },
    formatTime(val) {
      return formatTime(val)
    },
    formatNumWithComma(val) {
      return formatNumWithComma(val)
    }
  },
  data() {
    return {
      FaultData: {},
      drawerVisible: this.visible
    }
  },
  watch: {
    visible(val) {
      this.drawerVisible = val
      if (val && this.row.id) {
        // this.queryDetail(this.row.id)
        this.FaultData = {
          ...this.row
        }
      } else {
        this.FaultData = {}
      }
    }
  },
  methods: {
    createImgUrl,
    getDetail(id) {
      this.$ajax.get(this.$api.fault.fault_detail, { id }).then((res) => {
        this.FaultData = res.data
      })
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.hl-img {
  margin: 8px;
}
</style>
